var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.23398 0.75C5.42643 0.416667 5.90755 0.416667 6.1 0.75L7.83206 3.75C8.02451 4.08333 7.78394 4.5 7.39904 4.5H3.93494C3.55004 4.5 3.30948 4.08333 3.50193 3.75L5.23398 0.75Z",
    fill: "#26405E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1 9.25C5.90755 9.58333 5.42643 9.58333 5.23398 9.25L3.50193 6.25C3.30948 5.91667 3.55004 5.5 3.93494 5.5L7.39904 5.5C7.78394 5.5 8.02451 5.91667 7.83206 6.25L6.1 9.25Z",
    fill: "#26405E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/FilterIcon.e0f0333474f80782485cdc6aed2e2216.svg";
export { ForwardRef as ReactComponent };